// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3191":"88da6f4b0b93dda9","4081":"fde45b7613fcfbbc","4981":"ba265fe94bad3bb4","5270":"3d7332d5cd235750","8885":"cb5fe395de8423ed"}[chunkId] + ".css";
};